import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';

/* ***Layouts**** */
// const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')), 'full-preloader');   //?? check this full-preloader
import FullLayout from '../layouts/full/FullLayout';
import HomeView from '../views/HomeView/HomeView';
import GuideView from '../views/GuideView/GuideView';
// import SuccessView from '../views/SuccessView/SuccessView';
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')), 'full-preloader');

/* ****Pages***** */
const GuidesView = Loadable(lazy(() => import('../views/GuidesView/GuidesView')))
const BookingView = Loadable(lazy(() => import('../views/BookingView/BookingView')))
const ProfileView = Loadable(lazy(() => import('../views/ProfileView/ProfileView')))
const SettingsView = Loadable(lazy(() => import('../views/SettingsView/SettingsView')))
const LandingView = Loadable(lazy(() => import('../views/LandingView/LandingView')))
const TermsView = Loadable(lazy(() => import('../views/TermsView/TermsView')))
const StreamingView = Loadable(lazy(() => import('../views/StreamingView/StreamingView')))
const AdminView = Loadable(lazy(() => import('../views/AdminView/AdminView')))
const CreateGuideView = Loadable(lazy(() => import('../views/CreateGuideView/CreateGuideView')))
const Error = Loadable(lazy(() => import('../views/authentication/Error')), 'full-preloader');
const Register = Loadable(lazy(() => import('../views/authentication/Register')), 'full-preloader');
const Login = Loadable(lazy(() => import('../views/authentication/Login')), 'full-preloader');
const RedirectView = Loadable(lazy(() => import('../views/RedirectView/RedirectView')), 'full-preloader');
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/ForgotPassword')), 'full-preloader');
const ChangePassword = Loadable(lazy(() => import('../views/authentication/ChangePassword')), 'full-preloader');
const AuthView = Loadable(lazy(() => import('../views/AuthView/AuthView')), 'full-preloader');

const Router = [
  {
    path: '/travel',
    element: <FullLayout />,
    children: [
      { path: '/travel', exact: true, element: <HomeView /> },
      { path: '/travel/:guideId', exact: true, element: <GuideView /> },
      { path: '/travel/:guideId/create', exact: true, element: <BookingView /> },
      { path: '/travel/guides', exact: true, element: <GuidesView /> },
      { path: '/travel/profile', exact: true, element: <ProfileView /> },
      { path: '/travel/settings', exact: true, element: <SettingsView /> },
      { path: '/travel/landing', exact: true, element: <LandingView /> },
      { path: '/travel/terms', exact: true, element: <TermsView /> },
      { path: '/travel/streaming/:bookingsId', exact: true, element: <StreamingView /> },
      { path: '/travel/admin', exact: true, element: <AdminView /> },
      { path: '/travel/admin/create', exact: true, element: <CreateGuideView /> },
      { path: '/travel/admin/:guideAdminId', exact: true, element: <CreateGuideView /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '/auth', exact: true, element: <AuthView /> },
      { path: '404', element: <Error /> },
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/forgot-password', element: <ForgotPassword /> },
      { path: '/auth/change-password', element: <ChangePassword /> },
      { path: '/auth/redirect', element: <RedirectView /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
